var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('Notification'),_c('div',[_c('Header'),_c('v-main',[_c('v-container',[_c('router-view')],1)],1),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }